import { getRequest, type IRequestOptions } from '../../httpClient';
import type { IListPublicCollectionChallengesBySlugV2Response } from './list-public-collection-challenges-by-slug-v2-response';
import { listPublicCollectionChallengesBySlugV2ResponseSchema } from './list-public-collection-challenges-by-slug-v2-response';

export async function listPublicCollectionChallengesBySlugV2Api(
  slug: string,
  cursor?: string,
  options?: IRequestOptions,
) {
  return getRequest<IListPublicCollectionChallengesBySlugV2Response>({
    path: `/collections/v2/slug/${encodeURIComponent(slug)}/challenges`,
    options: cursor ? { ...options, params: { cursor } } : options,
    schema: listPublicCollectionChallengesBySlugV2ResponseSchema,
  });
}
